module.exports = __webpack_public_path__ + "img/male_income.7f3a4277.png";